import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const clearReschedulingByCorrelationIdAction = (
  state: PlanboardState,
  action: PayloadAction<string>
) => {
  const correlationId = action.payload;
  const machineIds = Object.keys(state.reschedulingFromPosition).map(Number);

  machineIds.forEach((machineId) => {
    const entries = state.reschedulingFromPosition[machineId];
    if (!entries) return;

    const filtered = entries.filter((entry) => entry.correlationId !== correlationId);
    if (filtered.length === 0) {
      delete state.reschedulingFromPosition[machineId];
    } else {
      state.reschedulingFromPosition[machineId] = filtered;
    }
  });
};
